var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.banner),function(image,index){return _c('van-swipe-item',{key:index,on:{"click":function($event){return _vm.onNavigate(image)}}},[_c('image-pic',{attrs:{"width":"100%","height":"150","src":image.url}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d62561a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/modules/Swiper.vue
// module id = null
// module chunks = 